import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, ViewChildren, Injectable, NgModule } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i5 from '@angular/material/button';
import { MatButton, MatButtonModule } from '@angular/material/button';
import * as i2 from '@angular/router';
import * as i3 from '@mare-common/ngx-mare-common';
import { NgxMareCommonModule } from '@mare-common/ngx-mare-common';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';

class NgxDynamicDialogConfig {
}
class NgxDynamicDialogButton {
    constructor() {
        /**
         * to be defined to switch correct action
         * if not provided an event is dispatched
         **/
        this.actionType = NgxDynamicDialogButtonActionTypeENUM.PUBLISHEVENT;
    }
}
var NgxDynamicDialogButtonActionTypeENUM;
(function (NgxDynamicDialogButtonActionTypeENUM) {
    NgxDynamicDialogButtonActionTypeENUM["CLOSE"] = "CLOSE";
    NgxDynamicDialogButtonActionTypeENUM["CUSTOM"] = "CUSTOM";
    NgxDynamicDialogButtonActionTypeENUM["GOTOLINK"] = "GOTOLINK";
    NgxDynamicDialogButtonActionTypeENUM["PUBLISHEVENT"] = "PUBLISHEVENT";
})(NgxDynamicDialogButtonActionTypeENUM || (NgxDynamicDialogButtonActionTypeENUM = {}));
class NgxDynamicDialogButtonActionType {
    static { this.CLOSE = NgxDynamicDialogButtonActionTypeENUM.CLOSE; }
    static { this.CUSTOM = NgxDynamicDialogButtonActionTypeENUM.CUSTOM; }
    static { this.GOTOLINK = NgxDynamicDialogButtonActionTypeENUM.GOTOLINK; }
    static { this.PUBLISHEVENT = NgxDynamicDialogButtonActionTypeENUM.PUBLISHEVENT; }
    constructor(value) {
        this.value = value;
        this.value = value || NgxDynamicDialogButtonActionTypeENUM.PUBLISHEVENT;
    }
}

class NgxDynamicDialogComponent {
    // define constructor for mat dialog
    constructor(dialogRef, router, injector, eventInteractionService, data) {
        this.dialogRef = dialogRef;
        this.router = router;
        this.injector = injector;
        this.eventInteractionService = eventInteractionService;
        this.data = data;
    }
    ngAfterViewInit() {
        this.dialogRef.afterOpened().subscribe(() => {
            let timeout = setTimeout(() => {
                this.actionButtons.last.nativeElement.focus();
                clearTimeout(timeout);
            }, 0);
        });
    }
    // define close method
    close() {
        this.dialogRef.close();
    }
    onClick(e, element) {
        if (element.actionType) {
            switch (element.actionType) {
                case NgxDynamicDialogButtonActionType.CUSTOM:
                    if (element.onClick) {
                        element.onClick(e, element);
                    }
                    else {
                        this.eventInteractionService.publishData({ event: 'dynamicDialogCustomEvent', data: this.data });
                    }
                    break;
                case NgxDynamicDialogButtonActionType.GOTOLINK:
                    if (element.link) {
                        window.open(element.link, '_blank');
                    }
                    else if (element.routelink && this.isRouteAvailable(element.routelink)) {
                        this.router.navigate([element.routelink]);
                        this.eventInteractionService.gotoLink(element.routelink);
                    }
                    else {
                        this.eventInteractionService.publishData({ event: 'dynamicDialogRouteLink', data: element.routelink });
                    }
                    break;
                case NgxDynamicDialogButtonActionType.PUBLISHEVENT:
                    this.eventInteractionService.publishData({ event: 'dynamicDialogEvent', data: this.data });
                    break;
                case NgxDynamicDialogButtonActionType.CLOSE:
                    this.close();
                    break;
                default:
                    this.eventInteractionService.publishData({ event: 'dynamicDialogClose' });
                    break;
            }
        }
        else {
            this.eventInteractionService.publishData({ event: 'dynamicDialogClose', data: this.data });
        }
    }
    isRouteAvailable(routelink) {
        const routeConfig = this.router.config;
        return routeConfig.some(route => route.path === routelink);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDialogComponent, deps: [{ token: i1.MatDialogRef }, { token: i2.Router }, { token: i0.Injector }, { token: i3.EventInteractionService }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: NgxDynamicDialogComponent, selector: "ngx-dynamic-dialog", viewQueries: [{ propertyName: "actionButtons", predicate: MatButton, descendants: true, read: ElementRef }], ngImport: i0, template: "<h3 class=\"ngx-dialog__subtitle\" *ngIf=\"data.subtitle\">{{ data.subtitle }}</h3>\n<h1 mat-dialog-title class=\"ngx-dialog__title\" *ngIf=\"data.title\">{{ data.title }}</h1>\n<div mat-dialog-content class=\"ngx-dialog__content\" *ngIf=\"data.content\" [innerHTML]=\"data.content\">\n</div>\n<div mat-dialog-actions *ngIf=\"data.buttons\" class=\"ngx-dialog__actions\">\n  <ng-container *ngIf=\"data.buttons; else noButtons\">\n    <button mat-flat-button *ngFor=\"let button of data.buttons\" \n    (click)=\"onClick($event, button)\" \n    [disabled]=\"button.disabled\"\n    [color]=\"button.color\"\n    [mat-dialog-close] = \"button.actionType !== 'CLOSE' ? data : null\"\n    >\n      {{button.label}}\n      <mat-icon *ngIf=\"button.icon\">{{button.icon}}</mat-icon>\n    </button>\n</ng-container>\n</div>\n<ng-template #noButtons>\n  <button mat-button (click)=\"close()\">Annulla</button>\n</ng-template>", styles: ["::ng-deep ngx-dynamic-dialog{height:100%;display:flex;flex-direction:column}.ngx-dialog__subtitle{margin:0;font-family:var(--mdc-dialog-subhead-font, Roboto, sans-serif);line-height:var(--mdc-dialog-subhead-line-height, 1.5rem);font-size:var(--mdc-dialog-subhead-size, .9rem);font-weight:var(--mdc-dialog-subhead-weight, 400);letter-spacing:var(--mdc-dialog-subhead-tracking, .03125em);padding:var(--mdc-dailog-padding-vertical, 16px) var(--mdc-dailog-padding-horizontal, 24px) 0;color:var(--mdc-dailog-color-subheading, #0025ff)}.ngx-dialog__subtitle+.ngx-dialog__title:before{height:20px}.ngx-dialog__title{--mdc-dialog-subhead-line-height:1;margin-bottom:var(--mdc-dailog-title-margin-vertical, 16px)}\n"], dependencies: [{ kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i5.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i6.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-dynamic-dialog', template: "<h3 class=\"ngx-dialog__subtitle\" *ngIf=\"data.subtitle\">{{ data.subtitle }}</h3>\n<h1 mat-dialog-title class=\"ngx-dialog__title\" *ngIf=\"data.title\">{{ data.title }}</h1>\n<div mat-dialog-content class=\"ngx-dialog__content\" *ngIf=\"data.content\" [innerHTML]=\"data.content\">\n</div>\n<div mat-dialog-actions *ngIf=\"data.buttons\" class=\"ngx-dialog__actions\">\n  <ng-container *ngIf=\"data.buttons; else noButtons\">\n    <button mat-flat-button *ngFor=\"let button of data.buttons\" \n    (click)=\"onClick($event, button)\" \n    [disabled]=\"button.disabled\"\n    [color]=\"button.color\"\n    [mat-dialog-close] = \"button.actionType !== 'CLOSE' ? data : null\"\n    >\n      {{button.label}}\n      <mat-icon *ngIf=\"button.icon\">{{button.icon}}</mat-icon>\n    </button>\n</ng-container>\n</div>\n<ng-template #noButtons>\n  <button mat-button (click)=\"close()\">Annulla</button>\n</ng-template>", styles: ["::ng-deep ngx-dynamic-dialog{height:100%;display:flex;flex-direction:column}.ngx-dialog__subtitle{margin:0;font-family:var(--mdc-dialog-subhead-font, Roboto, sans-serif);line-height:var(--mdc-dialog-subhead-line-height, 1.5rem);font-size:var(--mdc-dialog-subhead-size, .9rem);font-weight:var(--mdc-dialog-subhead-weight, 400);letter-spacing:var(--mdc-dialog-subhead-tracking, .03125em);padding:var(--mdc-dailog-padding-vertical, 16px) var(--mdc-dailog-padding-horizontal, 24px) 0;color:var(--mdc-dailog-color-subheading, #0025ff)}.ngx-dialog__subtitle+.ngx-dialog__title:before{height:20px}.ngx-dialog__title{--mdc-dialog-subhead-line-height:1;margin-bottom:var(--mdc-dailog-title-margin-vertical, 16px)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }, { type: i2.Router }, { type: i0.Injector }, { type: i3.EventInteractionService }, { type: NgxDynamicDialogConfig, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; }, propDecorators: { actionButtons: [{
                type: ViewChildren,
                args: [MatButton, { read: ElementRef }]
            }] } });

class NgxDynamicDialogService {
    constructor(dialog, eventInteractionService) {
        this.dialog = dialog;
        this.eventInteractionService = eventInteractionService;
        this.eventInteractionService.getObservable().subscribe((event) => {
            switch (event.event) {
                case 'showDialog':
                    this.openDialog();
                    break;
                case 'hideDialog':
                    this.hideDialog();
                    break;
                default:
                    break;
            }
        });
    }
    openDialog(dialogComponentConfig, dialogComponent) {
        console.log('showDialog');
        if (!dialogComponent) {
            dialogComponent = NgxDynamicDialogComponent;
        }
        const dialogRef = this.dialog.open(dialogComponent, {
            width: dialogComponentConfig?.width || '500px',
            height: dialogComponentConfig?.height || 'auto',
            maxHeight: dialogComponentConfig?.maxHeight || 'auto',
            maxWidth: dialogComponentConfig?.maxwidth || 'auto',
            data: dialogComponentConfig,
            panelClass: dialogComponentConfig?.panelClass || 'ngx-dialog__dynamic-dialog'
        });
        dialogRef.afterClosed().subscribe(result => {
            this.eventInteractionService.publishData({ event: 'dynamicDialogClose', data: result });
            // console.log'The dialog was closed');
        });
    }
    hideDialog() {
        console.log('hideDialog');
        this.dialog.closeAll();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDialogService, deps: [{ token: i1.MatDialog }, { token: i3.EventInteractionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDialogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialog }, { type: i3.EventInteractionService }]; } });

class NgxDynamicDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDialogModule, declarations: [NgxDynamicDialogComponent], imports: [CommonModule,
            NgxMareCommonModule,
            MatDialogModule,
            MatButtonModule,
            MatIconModule], exports: [NgxDynamicDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDialogModule, imports: [CommonModule,
            NgxMareCommonModule,
            MatDialogModule,
            MatButtonModule,
            MatIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NgxDynamicDialogComponent
                    ],
                    imports: [
                        CommonModule,
                        NgxMareCommonModule,
                        MatDialogModule,
                        MatButtonModule,
                        MatIconModule
                    ],
                    exports: [
                        NgxDynamicDialogComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of ngx-dynamic-dialog
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxDynamicDialogButton, NgxDynamicDialogButtonActionType, NgxDynamicDialogButtonActionTypeENUM, NgxDynamicDialogComponent, NgxDynamicDialogConfig, NgxDynamicDialogModule, NgxDynamicDialogService };
